import { useTranslation } from 'react-i18next';
import { Typography, TYPOGRAPHY_SIZE } from '@thinknet-gmbh/platform-common-ui';

import { InterviewTypeForm } from 'src/pages/settings/components/employee-development/components/interview-type-form';
import { useUpdateInterviewType } from 'src/hooks/interview-types/update-interview-type.hook';

import { EditContainer } from './interview-type-edit.styles';

const EditInterviewType = ({
  initialValues,
  onClose,
}: {
  initialValues: any;
  onClose: () => void;
}) => {
  const { t } = useTranslation('settings');

  const updateInterviewType = useUpdateInterviewType();

  const onEditSubmit = (values: any) => {
    updateInterviewType({
      variables: { interviewTypeId: initialValues._id, payload: values },
      onCompleted: onClose,
    });
  };

  return (
    <EditContainer>
      <Typography weight="bold" size={TYPOGRAPHY_SIZE.medium}>
        {t('employeeDevelopment.labels.typeDetails')}
      </Typography>
      <InterviewTypeForm onClose={onClose} onFinish={onEditSubmit} initialValues={initialValues} />
    </EditContainer>
  );
};

export default EditInterviewType;
